<div class="container">
    <div class="input-container">
        <h6 data-cy="channel-search-bar-placeholder" class="sub-title" [class.show]="value">
            {{ subTitle | translate }}
        </h6>
        <input
            data-cy="channel-search-bar"
            class="input"
            type="text"
            [(ngModel)]="value"
            [placeholder]="[!inputFocus ? (placeholder | translate) : '']"
            [maxLength]="maxlength"
            (input)="onInputChage()"
            (focus)="onInputFocus()"
            (blur)="onInputBlur()"
            (keydown)="onInputKeyDown($event)"
        />
    </div>
</div>
